import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  CircularProgress,
  Card,
  CardContent,
  Paper,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Chip,
} from "@mui/material";
import axios from "axios";
import baseURL from "../config";
import Navbar from "../Navbar/Navbar"; // ✅ Make sure this path is correct

const VesselOwnerRefundRequests = () => {
  const [requests, setRequests] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchRefundRequests();
  }, []);

  const fetchRefundRequests = async () => {
    try {
      const { data } = await axios.get(`${baseURL}/api/wallet/getAllRefundRequests`);
      setRequests(data);
    } catch (err) {
      console.error("❌ Error fetching refund requests:", err);
    } finally {
      setLoading(false);
    }
  };

  const renderStatusChip = (refund) => {
    if (refund.isRefunded) {
      return <Chip label="Refunded" color="success" />;
    } else if (refund.isAccepted) {
      return <Chip label="Accepted" color="warning" />;
    } else {
      return <Chip label="Pending" color="error" />;
    }
  };

  return (
    <>
      <Navbar /> {/* ✅ Add Navbar at the top */}
      <Box sx={{ p: 3 }}>
        <Typography variant="h5" fontWeight={600} mb={3}>
          Vessel Owner Refund Requests
        </Typography>

        {loading ? (
          <Box textAlign="center">
            <CircularProgress />
          </Box>
        ) : requests.length === 0 ? (
          <Typography>No refund requests found.</Typography>
        ) : (
          requests.map((owner) => (
            <Card key={owner._id} sx={{ mb: 3, boxShadow: 3, borderRadius: 2 }}>
              <CardContent>
                <Typography variant="h6">{owner.username}</Typography>
                <Typography variant="body2" color="text.secondary" gutterBottom>
                  {owner.email}
                </Typography>

                <Paper variant="outlined">
                  <Table>
                    <TableHead sx={{ backgroundColor: "#f5f5f5" }}>
                      <TableRow>
                        <TableCell><strong>Amount (USD)</strong></TableCell>
                        <TableCell><strong>Note</strong></TableCell>
                        <TableCell><strong>Date</strong></TableCell>
                        <TableCell><strong>Status</strong></TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {owner.refunds.map((refund, idx) => (
                        <TableRow key={idx}>
                          <TableCell>${refund.amount.toLocaleString()}</TableCell>
                          <TableCell>{refund.note || "-"}</TableCell>
                          <TableCell>{new Date(refund.date).toLocaleString()}</TableCell>
                          <TableCell>{renderStatusChip(refund)}</TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </Paper>
              </CardContent>
            </Card>
          ))
        )}
      </Box>
    </>
  );
};

export default VesselOwnerRefundRequests;
